/**
 * Cookie Policy Page
 * Cookie policy compliant with EU regulations
 */

import { renderNavbar } from '../components/navbar.js';
import { renderFooter } from '../components/footer.js';

export function renderCookies(container) {
    container.innerHTML = `
    ${renderNavbar()}
    
    <main class="legal-page">
      <div class="container">
        <div class="legal-content animate-fadeIn">
          <h1 class="legal-title">Política de Cookies</h1>
          <p class="legal-updated">Última actualización: 9 de enero de 2026</p>
          
          <section class="legal-section">
            <h2>1. ¿Qué son las Cookies?</h2>
            <p>
              Las cookies son pequeños archivos de texto que los sitios web almacenan en 
              tu dispositivo (ordenador, móvil, tablet) cuando los visitas. Sirven para 
              recordar tus preferencias, mejorar tu experiencia de navegación y proporcionarnos 
              información sobre cómo utilizas nuestro sitio.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>2. Cookies que Utilizamos</h2>
            
            <h3>2.1 Cookies Esenciales</h3>
            <p>
              Estas cookies son necesarias para el funcionamiento del sitio. Sin ellas, 
              el servicio no funcionaría correctamente.
            </p>
            <table class="legal-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Proveedor</th>
                  <th>Propósito</th>
                  <th>Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>hipoteca_user</td>
                  <td>HipotecaFácil</td>
                  <td>Mantener la sesión de usuario</td>
                  <td>Sesión</td>
                </tr>
                <tr>
                  <td>hipoteca_token</td>
                  <td>HipotecaFácil</td>
                  <td>Autenticación con el servidor</td>
                  <td>7 días</td>
                </tr>
              </tbody>
            </table>
            
            <h3>2.2 Cookies de Rendimiento/Analíticas</h3>
            <p>
              Nos ayudan a entender cómo los usuarios interactúan con el sitio para 
              poder mejorar su funcionamiento.
            </p>
            <table class="legal-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Proveedor</th>
                  <th>Propósito</th>
                  <th>Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>_ga</td>
                  <td>Google Analytics</td>
                  <td>Distinguir usuarios únicos</td>
                  <td>2 años</td>
                </tr>
                <tr>
                  <td>_ga_*</td>
                  <td>Google Analytics</td>
                  <td>Mantener el estado de la sesión</td>
                  <td>2 años</td>
                </tr>
              </tbody>
            </table>
            
            <h3>2.3 Cookies de Autenticación</h3>
            <p>
              Utilizadas por Firebase para gestionar la autenticación de usuarios.
            </p>
            <table class="legal-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Proveedor</th>
                  <th>Propósito</th>
                  <th>Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>__session</td>
                  <td>Firebase</td>
                  <td>Autenticación de usuario</td>
                  <td>Sesión</td>
                </tr>
              </tbody>
            </table>
          </section>
          
          <section class="legal-section">
            <h2>3. Cookies de Terceros</h2>
            <p>Además de nuestras propias cookies, utilizamos cookies de terceros:</p>
            <ul>
              <li>
                <strong>Firebase (Google):</strong> Para autenticación y análisis
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener" 
                   style="color: var(--primary-600);">Política de Privacidad de Google</a>
              </li>
              <li>
                <strong>Stripe:</strong> Para procesamiento seguro de pagos
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener" 
                   style="color: var(--primary-600);">Política de Privacidad de Stripe</a>
              </li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>4. Cómo Gestionar las Cookies</h2>
            <p>
              Puedes gestionar y/o eliminar las cookies según tus preferencias. 
              A continuación te explicamos cómo hacerlo en los principales navegadores:
            </p>
            <ul>
              <li>
                <strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies y otros datos de sitios
              </li>
              <li>
                <strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies y datos del sitio
              </li>
              <li>
                <strong>Safari:</strong> Preferencias → Privacidad → Cookies y datos de sitios web
              </li>
              <li>
                <strong>Edge:</strong> Configuración → Cookies y permisos del sitio → Cookies
              </li>
            </ul>
            <div class="alert alert-info">
              <i data-feather="info"></i>
              <div>
                Ten en cuenta que desactivar las cookies puede afectar al funcionamiento 
                del servicio. Las cookies esenciales son necesarias para que la aplicación 
                funcione correctamente.
              </div>
            </div>
          </section>
          
          <section class="legal-section">
            <h2>5. Base Legal</h2>
            <p>
              La base legal para el uso de cookies es:
            </p>
            <ul>
              <li><strong>Cookies esenciales:</strong> Interés legítimo (necesarias para el funcionamiento)</li>
              <li><strong>Cookies analíticas:</strong> Consentimiento del usuario</li>
              <li><strong>Cookies de terceros:</strong> Consentimiento del usuario</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>6. Actualizaciones</h2>
            <p>
              Esta política puede actualizarse periódicamente. Te recomendamos 
              revisarla de vez en cuando para estar informado de cualquier cambio.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>7. Contacto</h2>
            <p>
              Si tienes preguntas sobre nuestra política de cookies, contacta con nosotros en:
              <strong>privacidad@hipotecafacil.es</strong>
            </p>
          </section>
          
          <div class="legal-footer">
            <a href="/" data-link class="btn btn-secondary">
              <i data-feather="arrow-left"></i>
              Volver al inicio
            </a>
          </div>
        </div>
      </div>
    </main>
    
    <style>
      .legal-table {
        width: 100%;
        border-collapse: collapse;
        margin: 16px 0;
        font-size: 14px;
      }
      
      .legal-table th,
      .legal-table td {
        padding: 12px;
        text-align: left;
        border: 1px solid var(--gray-200);
      }
      
      .legal-table th {
        background: var(--gray-50);
        font-weight: 600;
        color: var(--gray-700);
      }
      
      .legal-table td {
        color: var(--gray-600);
      }
      
      .legal-table tr:nth-child(even) td {
        background: var(--gray-50);
      }
    </style>
    
    ${renderFooter()}
  `;
}
